import { render, staticRenderFns } from "./CardProducto.vue?vue&type=template&id=467f95ec&scoped=true"
import script from "./CardProducto.vue?vue&type=script&lang=js"
export * from "./CardProducto.vue?vue&type=script&lang=js"
import style0 from "./CardProducto.vue?vue&type=style&index=0&id=467f95ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467f95ec",
  null
  
)

export default component.exports